var _ellipse, _path, _rect, _rect2, _path2, _rect3, _rect4, _line, _line2, _line3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 52,
    rx: 25,
    ry: 8,
    fill: "#CDD0D9",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1247 12.1176C15.057 10.9688 15.9704 10 17.1212 10H50.8788C52.0296 10 52.943 10.9688 52.8753 12.1176L50.5199 52.1176C50.4577 53.1746 49.5823 54 48.5234 54H19.4764C18.4175 54 17.5421 53.1746 17.4799 52.1176L15.1247 12.1176Z",
    fill: "#CDD0D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 20,
    height: 6,
    rx: 1,
    fill: "#BDC0CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 16,
    height: 6,
    rx: 1,
    fill: "#CDD0D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1178 12.1114C15.0538 10.9648 15.9663 10 17.1147 10H48.8853C50.0337 10 50.9462 10.9648 50.8822 12.1114L48.6508 52.1114C48.5917 53.171 47.7152 54 46.6539 54H19.3459C18.2846 54 17.4081 53.171 17.349 52.1114L15.1178 12.1114Z",
    fill: "#DBDCDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#BDC0CA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#CDD0D9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 21,
    x2: 33,
    y2: 43,
    stroke: "#BFC2CA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 43.9559,
    y1: 21.0834,
    x2: 42.0385,
    y2: 42.9996,
    stroke: "#BDC0CA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.9635,
    y1: 43.091,
    x2: 22.0461,
    y2: 21.1747,
    stroke: "#BEC2CA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f44c5806.svg";
export { ForwardRef as ReactComponent };